import { ApiNotificacao } from "./api-notificacao";
import { NegocioRealizado } from "./negocio-realizado";

export class NegocioRealizadoResult {
    success: boolean;
    data: NegocioRealizado;
    notifications: ApiNotificacao[];
    errors: string[];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
